import React from "react";
import useAtolInfoController from "./useAtolInfo.controller";
import { UIFlightData } from "@flights/types";
import { ATOLLogo } from "../../../../../ATOL/ATOLLogo";
import { Stack, Text } from "@bookingcom/bui-react";

const useAtolInfo = (flight: UIFlightData) => {
  const { header, atolText } = useAtolInfoController(flight);

  if (!atolText) return undefined;

  return {
    header,
    content: (
      <Stack direction="row" gap={4}>
        <ATOLLogo />
        <Stack.Item grow={true}>
          <Text variant="body_2">{atolText}</Text>
        </Stack.Item>
      </Stack>
    )
  };
};

export default useAtolInfo;
